import React, { useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'
import { hidePersonalJackpotNotify } from 'features/notifies/actions'
import { selectNotifies } from 'features/notifies/selectors'

import NotifyContainer from '../NotifyContainer/NotifyContainer'
import PersonalJackpotsPolling from './PersonalJackpotsPolling/PersonalJackpotsPolling'

const PersonalJackpotNotify = () => {
  const dispatch = useDispatch()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses
  const { all: allJackpots, hide: hiddenJackpots } = useSelector(selectNotifies, shallowEqual).personalJackpot

  const [isTemporarilyShowed, setIsTemporarilyShowed] = useState(false)

  const hideTemporarily = () => {
    setIsTemporarilyShowed(true)
  }

  const hideNotify = (id: number) => {
    dispatch(hidePersonalJackpotNotify(id))
  }

  const items = useMemo(
    () =>
      allJackpots
        .filter(jackpot => !hiddenJackpots.includes(jackpot.id))
        .map(jackpot => {
          const currID = jackpot.id
          const amount = `${jackpot.amount}`

          return (
            <NotifyContainer
              key={currID}
              title={locale.yourJackpot}
              value={amount}
              callback={() => hideNotify(currID)}
              hideTemporarily={hideTemporarily}
              currency={jackpot.amountCurrency}
            />
          )
        }),
    [allJackpots, hiddenJackpots, hideNotify, locale.yourJackpot],
  )

  return isAuth ? (
    <>
      <PersonalJackpotsPolling />
      {!isTemporarilyShowed ? items : null}
    </>
  ) : null
}

export default PersonalJackpotNotify
